export const queryBuilder = (paramsObj = {}) => {
    const query = new URLSearchParams()

    const appendParam = (key, value) => {
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item !== undefined && item !== null && item !== '') {
                    query.append(key, item)
                }
            })
        } else if (typeof value === 'object' && value !== null) {
            // Flatten one level only (basic support for nested objects)
            Object.entries(value).forEach(([nestedKey, nestedValue]) => {
                if (
                    nestedValue !== undefined &&
                    nestedValue !== null &&
                    nestedValue !== ''
                ) {
                    query.append(`${key}[${nestedKey}]`, nestedValue)
                }
            })
        } else {
            if (value !== undefined && value !== null && value !== '') {
                query.append(key, value)
            }
        }
    }

    Object.entries(paramsObj).forEach(([key, value]) => {
        appendParam(key, value)
    })

    return query.toString()
}

// helpers/cleanObject.js
export const cleanObject = (obj) => {
    if (!obj || typeof obj !== 'object') return {}

    return Object.entries(obj).reduce((acc, [key, value]) => {
        const isEmptyArray = Array.isArray(value) && value.length === 0
        const isEmptyObject =
            typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.keys(value).length === 0
        const isBlankString = typeof value === 'string' && value.trim() === ''

        if (
            value === null ||
            value === undefined ||
            isEmptyArray ||
            isEmptyObject ||
            isBlankString
        ) {
            return acc // Skip this key
        }

        acc[key] = value
        return acc
    }, {})
}
